<template>
	<div>
		<headdv ></headdv>
		<div style="height:80px;"></div>
		<div class="content_dv" :style="{height:(screenHeight-80-28)+'px'}">
			<div class="content_dv_dv">
				<div class="big_dv">
					<div id="stars" ref="stars">
						<!-- <div class="star" :style="{top:item.top + 'px',left: item.left + 'px'}" v-for="(item,index) in liuxingArr" :key="index"></div> -->
						<div data-v-f33e1f46="" class="star" style="animation-delay: 0s;"></div>
							<div data-v-f33e1f46="" class="star" style="top: -79px; left: 939px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 56px; left: 1270px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 317px; left: 1039px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: -9px; left: 300px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 340px; left: 930px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 312px; left: 868px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: -98px; left: 1194px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 260px; left: 577px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 441px; left: 1195px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 38px; left: 540px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 216px; left: 1020px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 207px; left: 1127px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 214px; left: 1117px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 313px; left: 740px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 127px; left: 1180px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 438px; left: 760px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 98px; left: 1044px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 115px; left: 1033px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 154px; left: 571px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 66px; left: 413px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 33px; left: 1035px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 104px; left: 427px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 234px; left: 656px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 231px; left: 1075px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 325px; left: 605px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 360px; left: 1022px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 170px; left: 989px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 4px; left: 920px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 331px; left: 1189px;"></div>
							<div data-v-f33e1f46="" class="star" style="top: 314px; left: 1134px;"></div>
						<div class="inex_time_dv">
							<p>{{timeVal}}</p>
							<p>{{lunarCalendar}}</p>
						</div>
					</div>

				</div>
								
			</div>
		</div>
		<!-- 底部 -->
		<footerdv></footerdv>
		
	</div>
</template>
<script>
export default {
	data() {
		return {
			timeVal:'',
			lunarCalendar:'',
         liuxingArr : [
				{top:'',left:'',}
			],
			screenHeight: document.documentElement.clientHeight ,// 屏幕高度
		};
	},
	created() {
		this.fromatTimeFun()
		
	},
	mounted(){
		this.startLiuxingFun()
	},
	methods: {
		fromatTimeFun(){
			setInterval(() => {
				this.timeVal = this.gettime.format(Date.parse(new Date()),6)
            this.lunarCalendar = this.gettime.getNonLiFun()
			}, 1000);            
		},
		// 生成流星动画
		startLiuxingFun(){
			//let stars = document.getElementById('stars')
			let stars = this.$refs.stars
         let strHtml = ''
			// js随机生成流星
			for(var j = 0; j < 30; j++) {
				let obj = {
					top:this.randomDistance(500, -100),
					left:this.randomDistance(1300, 300),
				}
				this.liuxingArr.push(obj)
			}
			var star = document.getElementsByClassName('star')

			// 给流星添加动画延时
			for(var i = 0, len = star.length; i < len; i++) {　　
				star[i].style.animationDelay = i % 6 == 0 ? '0s' : i * 0.8 + 's'
			}
		},
		// 封装随机数方法
		randomDistance(max, min) {
			var distance = Math.floor(Math.random() * (max - min + 1) + min)
			return distance
		}
	},
};
</script>
<style lang="scss" scoped>
.content_dv{
	padding:0;
}
.inex_time_dv{
	position:absolute;
	top:30%;
	left:50%;
	transform: translate(-50%,-50%);
        margin-top:50px;
        p{
            font-size: 18px;
            font-weight: 900;
            text-align: center;
            color: #1069e8;
            line-height:50px;
            
        }
   }


.big_dv{
	position: relative;
	width: 100%;
	height: 100%;
	margin: 0;
	overflow: hidden;
	/*background: linear-gradient(rgba(0, 108, 172, 1), rgba(0, 122, 195, .7));*/
	background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%);
	padding-left: 210px;
	box-sizing: border-box;
	#stars {
		margin: 0 auto;
		max-width: 1600px;
		position: fixed;
		top: 80px;
    	left: 210px;
		right: 0;
		bottom: 0;
		z-index: 2;
		.star {
			display: block;
			width: 1px;
			background: transparent;
			position: relative;
			opacity: 0;
			/*过渡动画*/
			animation: star-fall 3s linear infinite;
			-webkit-animation: star-fall 3s linear infinite;
			-moz-animation: star-fall 3s linear infinite;
		}
		.star:after {
			content: '';
				display: block;
				border: 0px solid #fff;
				border-width: 0px 90px 2px 90px;
				border-color: transparent transparent transparent rgba(255, 255, 255, .5);
				box-shadow: 0 0 1px 0 rgba(255, 255, 255, .1);
				/*变形*/
				transform: rotate(-45deg) translate3d(1px, 3px, 0);
				-webkit-transform: rotate(-45deg) translate3d(1px, 3px, 0);
				-moz-transform: rotate(-45deg) translate3d(1px, 3px, 0);
				transform-origin: 0% 100%;
				-webkit-transform-origin: 0% 100%;
				-moz-transform-origin: 0% 100%;
		}
	}
}

@keyframes star-fall {
	0% {
		opacity: 0;
		transform: scale(0.5) translate3d(0, 0, 0);
		-webkit-transform: scale(0.5) translate3d(0, 0, 0);
		-moz-transform: scale(0.5) translate3d(0, 0, 0);
	}
	50% {
		opacity: 1;
		transform: translate3d(-200px, 200px, 0);
		-webkit-transform: translate3d(-200px, 200px, 0);
		-moz-transform: translate3d(-200px, 200px, 0);
	}
	100% {
		opacity: 0;
		transform: scale(1.2) translate3d(-300px, 300px, 0);
		-webkit-transform: scale(1.2) translate3d(-300px, 300px, 0);
		-moz-transform: scale(1.2) translate3d(-300px, 300px, 0);
	}
}
</style>